import styled from "styled-components";

export const HeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	gap: 15px;

	@media (max-width: 620px) {
		flex-direction: column;
		align-items: flex-start;
		gap: 12px;
	}
`;

export const PatientContainer = styled.div<{ isV1Mode: boolean }>`
	display: grid;
	grid-template-columns: ${({ isV1Mode }) =>
		isV1Mode ? "auto 1fr" : "auto 1fr auto"};
	align-items: center;
	gap: 13px;
	transition: background-color 0.22s, border-color 0.22s;
	flex: 1;
	width: 100%;

	${({ isV1Mode }) => {
		if (isV1Mode) {
			return `
				background: transparent;
				border: 0;
				padding: 0;
			`;
		}
		// V2 completo
		return `
			background: rgba(255, 255, 255, 0.05);
			border: 1px solid rgba(255, 255, 255, 0.15);
			border-radius: 8px;
			padding: 10px 14px;
			cursor: pointer;
			&:hover {
				background: rgba(255, 255, 255, 0.08);
				border-color: rgba(255, 255, 255, 0.25);
			}
		`;
	}}
`;

export const AvatarWrapper = styled.div<{ hasPhoto?: boolean }>`
	width: 42px;
	height: 42px;
	border-radius: 50%;
	display: grid;
	place-items: center;
	background: #000e4b;
	color: #ffffff;
	font-weight: 800;
	font-size: 14px;
	font-family: "NotoSans-Bold", sans-serif;
	border: ${({ hasPhoto }) => (hasPhoto ? "0" : "2px solid #ffffff")};
	box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
	position: relative;
	overflow: hidden;
`;

export const Photo = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

export const PatientInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const PatientName = styled.span`
	font-family: "NotoSans-Bold", sans-serif;
	font-size: 20px;
	font-weight: 700;
	color: #ffffff;
	margin-bottom: 3px;
	display: block;
`;

export const PatientDate = styled.span`
	font-family: "NotoSans-Regular", sans-serif;
	font-size: 10px;
	color: #bad2ff;
`;

export const PatientSideArea = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	justify-content: flex-end;
	flex-shrink: 0;

	@media (max-width: 620px) {
		width: 100%;
		justify-content: space-between;
	}
`;

export const TagsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-end;
	gap: 5px;
	max-width: 165px;

	@media (max-width: 620px) {
		max-width: 100%;
		justify-content: flex-start;
	}
`;

export const Tag = styled.span`
	background: #ff9f4325;
	color: #ffc400;
	padding: 6px 9px;
	border-radius: 15px;
	font-size: 9px;
	font-weight: 800;
	font-family: "NotoSans-Bold", sans-serif;
	white-space: nowrap;
`;

export const ProfessionalAvatar = styled.div`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	border: 2px solid #00a377;
	position: relative;
	overflow: hidden;
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
	flex-shrink: 0;

	&::after {
		content: "";
		position: absolute;
		bottom: 0;
		right: 0;
		width: 8px;
		height: 8px;
		background-color: #00d395;
		border-radius: 50%;
		border: 1px solid #ffffff;
	}
`;

export const ChevronRight = styled.span`
	font-size: 25px;
	color: #ffffff;
	line-height: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: 5px;
	user-select: none;
`;
